import React from 'react';
//import GoogleMapReact from 'google-map-react';
//import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

const GoogleMap = ({ blok, dynamicData }) => {
  // console.log(blok);

  return (<></>);

  /*
  const defaultProps = {
    center: {
      lat: 57.69721634340465,
      lng: 11.976116999692321,
    },
    zoom: 15,
  };

  return (
    // Important! Always set the container height explicitly
    <div
      style={{ height: blok.height || '100vh', width: blok.width || '100%' }}
      {...storyblokEditable(blok)}
    >
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_API_KEY }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        zoom={blok.zoom_level}
      >
        {blok.map_markers &&
          blok.map_markers.map((nestedBlok) => (
            <StoryblokComponent
              lat={nestedBlok.latitude_marker}
              lng={nestedBlok.longitude_marker}
              blok={nestedBlok}
              key={nestedBlok._uid}
            />
          ))}
      </GoogleMapReact>
    </div>
  );*/


};

export default GoogleMap;
